import { createTestIds } from '../../utils';

export const elements = [
  'label',
  'info',
  'additional-info',
  'suggestion-accept',
  'suggestion-reject'
] as const;

export const getFormFieldTestIds = createTestIds('form-field', elements);
